import { MessageFormat } from '@paypalcorp/worldready'

import { EU_COUNTRIES } from '@/constants/common'

const MISSING_MESSAGE = 'missingMessage'

const BACK_UP_FUNDING_COUNTRIES = ['DE', 'AT']

/**
 * Port of debit-card-client withWorldReadyCountrySwitching for components.v2.* keys.
 */
export function withWorldReadyCountrySwitching({ country = 'US' }, worldReady, path) {
  const upperCountry = (country || 'US').toUpperCase()

  const i18n = (key, variableList = {}) =>
    getWorldReadyFormattedMessage(key, path, upperCountry, worldReady, variableList, true)[0]

  i18n.keyName = (key, variableList = {}) =>
    getWorldReadyFormattedMessage(key, path, upperCountry, worldReady, variableList, false)[1]

  i18n.keyExists = (key, variableList = {}) => {
    const retrievedString = getWorldReadyFormattedMessage(
      key,
      path,
      upperCountry,
      worldReady,
      variableList,
      false,
    )[0]
    return retrievedString === null
  }

  return i18n
}

// eslint-disable-next-line max-params -- mirrors debit-card-client l10n helper signature
function getWorldReadyFormattedMessage(key, path, country, worldReady, variableList, formatString) {
  const worldReadyStringId = path + key

  if (!EU_COUNTRIES.includes(country)) {
    const countryKey = worldReadyStringId + '_' + country
    const countryString = retrieveMessage(worldReady, countryKey, variableList, formatString)
    if (countryString !== countryKey) {
      return [countryString, countryKey]
    }
    return [
      retrieveMessage(worldReady, worldReadyStringId, variableList, formatString),
      worldReadyStringId,
    ]
  }

  const euRegionPrefix = BACK_UP_FUNDING_COUNTRIES.includes(country) ? 'EU_DE' : 'EU_GB'

  const countrySpecificKey = worldReadyStringId + '_' + country
  const countrySpecificString = retrieveMessage(
    worldReady,
    countrySpecificKey,
    variableList,
    formatString,
  )
  if (countrySpecificString !== countrySpecificKey) {
    return [countrySpecificString, countrySpecificKey]
  }

  const euRegionKey = worldReadyStringId + '_' + euRegionPrefix
  const euRegionString = retrieveMessage(worldReady, euRegionKey, variableList, formatString)
  if (euRegionString !== euRegionKey) {
    return [euRegionString, euRegionKey]
  }

  const euCommonKey = worldReadyStringId + '_EU'
  const euCommonString = retrieveMessage(worldReady, euCommonKey, variableList, formatString)
  if (euCommonString !== euCommonKey) {
    return [euCommonString, euCommonKey]
  }

  return [
    retrieveMessage(worldReady, worldReadyStringId, variableList, formatString),
    worldReadyStringId,
  ]
}

function retrieveMessage(worldReady, stringId, variables, formatString) {
  try {
    if (formatString) {
      return new MessageFormat(worldReady, { id: stringId }).format(variables)
    }

    const messageFormatObject = new MessageFormat(worldReady, { id: stringId })
    if (
      messageFormatObject.messageParts &&
      messageFormatObject.messageParts[0] &&
      messageFormatObject.messageParts[0].type === MISSING_MESSAGE
    ) {
      return stringId
    }
    return null
  } catch {
    // WorldReady namespaces load lazily in OSLO/Venice webviews — treat as missing.
    return stringId
  }
}
